import { useMemo } from 'react';
import { formatPercentage } from '../../../CommonUtils/formatNumber';
import { usePerformanceQuery } from '../../api/usePerformanceQuery';
import { usePeriod } from '../../hooks/usePeriod';
import { useOptions } from '../../hooks/useOptions';
import { useRouteParams } from '../../hooks/useRouteParams';

export const usePeriodReturn = () => {
  const period = usePeriod();

  const { performancePeriodOptions } = useOptions();

  const { accountId, clientId, groupId } = useRouteParams();

  const queryInfo = usePerformanceQuery({
    clientId,
    period: period.value,
    startDate: period.dates[0],
    endDate: period.dates[1],
    accountId,
    groupId,
  });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { portfolioPeriodReturn } = queryInfo.data;

    const periodOption = performancePeriodOptions.find(({ value }) => value === period.value);

    return {
      label: periodOption ? `${periodOption.label} Return` : 'Return',
      value:
        typeof portfolioPeriodReturn === 'number'
          ? formatPercentage(portfolioPeriodReturn / 100, { decimalPlaces: 2 })
          : null,
    };
  }, [queryInfo.data, performancePeriodOptions, period]);

  return { ...queryInfo, data };
};
